module.exports = __webpack_public_path__ + "img/S-WEB-Goal-02.4055d459.png";